export const SET_USER = "SET_USER";
export const SET_LEVEL_COMPLETION_DATA = "SET_LEVEL_COMPLETION_DATA";
export const UPDATE_LEVEL_COMPLETION_DATA = "UPDATE_LEVEL_COMPLETION_DATA";
export const SET_USER_STATS = "SET_USER_STATS";



// WEBPACK FOOTER //
// ./src/actionCreators/userActionNames.js